import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";

let _ = t => t,
    _t,
    _t2,
    _t3;

import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import PlanBuilder from '../plan-builder/PlanBuilder';
import SummaryColumn from '../plan-builder/SummaryColumn';
import styled from 'styled-components';
import UITile from 'UIComponents/tile/UITile';
import UITileSection from 'UIComponents/tile/UITileSection';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { CALYPSO_DARK } from 'HubStyleTokens/colors';
import UIIcon from 'UIComponents/icon/UIIcon';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import breakpoint from 'pricing-pages-ui/constants/Breakpoints';
import { SectionTitle } from '../common/SharedComponents';
import { useIsMobile } from '../../context/IsMobileContext';
import { SummaryColumnWrapper } from '../plan-builder/SharedComponents';
const RotatedIcon = styled(UIIcon).withConfig({
  displayName: "Calculator__RotatedIcon",
  componentId: "sc-1x8kgzf-0"
})(["transform:rotate(-90deg);"]);
const ResponsiveTileSection = styled(UITileSection).withConfig({
  displayName: "Calculator__ResponsiveTileSection",
  componentId: "sc-1x8kgzf-1"
})(["", ""], breakpoint.phone(_t || (_t = _`
    padding: 20px;
  `)));
const ContentContainer = styled.div.withConfig({
  displayName: "Calculator__ContentContainer",
  componentId: "sc-1x8kgzf-2"
})(["", ""], breakpoint.tablet(_t2 || (_t2 = _`
    width: 100%;
  `)));
const PlanSelectorContainer = styled(UITile).withConfig({
  displayName: "Calculator__PlanSelectorContainer",
  componentId: "sc-1x8kgzf-3"
})(["min-width:610px;", ""], breakpoint.phone(_t3 || (_t3 = _`
    min-width: auto;
    width: inherit;
  `)));

const BackToTopLink = () => {
  const isMobile = useIsMobile();
  return /*#__PURE__*/_jsx(UIFlex, {
    justify: isMobile ? 'center' : 'end',
    children: /*#__PURE__*/_jsxs(UILink, {
      className: "m-y-2",
      onClick: () => {
        window.scrollTo({
          top: 0,
          behavior: 'smooth'
        });
        getUsageTracker().track('scrollInteraction', {
          name: 'calculator',
          action: 'clicked back to top'
        });
      },
      children: [/*#__PURE__*/_jsx(RotatedIcon, {
        name: "next",
        size: "small",
        color: CALYPSO_DARK
      }), /*#__PURE__*/_jsx(FormattedMessage, {
        message: "planBuilder.productPages.backToTop"
      })]
    })
  });
};

const Calculator = ({
  planBuilderProps,
  planSelectorComponent,
  className,
  hideCrmSuiteAlert = false
}) => {
  const elementId = 'calculator';
  const {
    initialProductConfigurations
  } = planBuilderProps;
  const foundConfig = initialProductConfigurations ? initialProductConfigurations.find(config => config && config.skuId) : null;
  const key = foundConfig ? foundConfig.skuId : 'initial';
  return /*#__PURE__*/_jsx("div", {
    id: elementId,
    className: className,
    style: {
      position: 'relative',
      flexDirection: 'column',
      width: '100%'
    },
    children: /*#__PURE__*/_jsxs("div", {
      style: {
        position: 'relative',
        zIndex: 1
      },
      children: [/*#__PURE__*/_jsx(SectionTitle, {
        "aria-level": 2,
        className: "text-center m-bottom-0",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "planBuilder.productPages.title"
        })
      }), /*#__PURE__*/_jsx(PlanBuilder, Object.assign({
        headerContent: /*#__PURE__*/_jsx(BackToTopLink, {})
      }, planBuilderProps, {
        children: /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ContentContainer, {
            className: "flex-column",
            style: {
              flex: 1
            },
            children: /*#__PURE__*/_jsx(PlanSelectorContainer, {
              children: /*#__PURE__*/_jsx(ResponsiveTileSection, {
                children: planSelectorComponent
              })
            })
          }), /*#__PURE__*/_jsx(SummaryColumnWrapper, {
            className: "flex-column",
            children: /*#__PURE__*/_jsx(SummaryColumn, {
              shareLinkAnchor: elementId,
              hideCrmSuiteAlert: hideCrmSuiteAlert
            })
          })]
        })
      }), key)]
    })
  });
};

export default Calculator;